import { render, staticRenderFns } from "./codemirror.vue?vue&type=template&id=1401836e&"
import script from "./codemirror.vue?vue&type=script&lang=js&"
export * from "./codemirror.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports